import { render } from "./transmitting.vue?vue&type=template&id=152ae3ca&scoped=true"
import script from "./transmitting.vue?vue&type=script&lang=js"
export * from "./transmitting.vue?vue&type=script&lang=js"

import "./transmitting.vue?vue&type=style&index=0&id=152ae3ca&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152ae3ca"]])

export default __exports__